import { useQuery } from "@apollo/client";

import { QUERY_DIGITAL_RECEPTION } from "../../../../../config/graphql/query";
import {
  CUSTOMIZABLE_LAYOUT_RECEPTIONS,
  POST_CHECKIN_FORM_RECEPTIONS,
} from "../../../../../config/const/common";

/**
 * A reception that asks questions after a check-in but never checks anyone in with a set -- its
 * check-in is built into the bundle. There a set can only be a form, so the page says questions.
 *
 * These pages are top-level routes, so on a refresh the query has to run: until it answers the
 * page reads as a manual registration and then flips.
 */
export const useIsQuestionsReception = (screenId?: string): boolean => {
  const { data } = useQuery<{ digitalReception: { template: string } }>(
    QUERY_DIGITAL_RECEPTION,
    {
      variables: { id: screenId },
      skip: !screenId,
    },
  );

  const template = data?.digitalReception?.template ?? "";

  return (
    POST_CHECKIN_FORM_RECEPTIONS.includes(template) &&
    !CUSTOMIZABLE_LAYOUT_RECEPTIONS.includes(template)
  );
};

export default useIsQuestionsReception;
